let questionMark = document.querySelector('.product__form__outer .btn-question-mark');
if (questionMark) {
    questionMark.addEventListener("click", myFunction);

    function myFunction() {
        document.querySelector('body').classList.add('body-no-scroll');
        document.querySelector('.product-modal__close').addEventListener("click", myFunction2);

        function myFunction2() {
            document.querySelector('body').classList.remove('body-no-scroll');
        }
    }

    if (document.querySelector('.product-modal').getAttribute("open") == null) {
        document.querySelector('body').classList.remove('body-no-scroll');
    }

    window.onclick = function (event) {
        var myBox = document.querySelector('.product-modal__inner');

        if (event.target.contains(myBox) && event.target !== myBox) {
            document.querySelector('body').classList.remove('body-no-scroll');
        }
    }
}
